export let urlParams = new URLSearchParams(window.location.search + window.location.hash)